module.exports = __webpack_public_path__ + "static/media/lys-is-wrong.f2eda4ec.mp3";